<script setup>
import i18n from "@/i18n"
import {
    defineProps, defineEmits, 
    computed,
    ref

} from "vue";

const props = defineProps({
    customFieldsList: {
        type: Array,
        required: true,
        default: () => []
    },
})

const emits = defineEmits(["update:customFieldsList"])
const customFieldsList = ref(computed(() => props.customFieldsList))

const changeName = () => {
    emits('update:customFieldsList', customFieldsList.value)
}

</script>
<template>
    <template v-for="(item, index) in customFieldsList" :key="index">
        <b-card>
            <div class="row gy-3 w-100">
                <div class="d-flex justify-content-between align-items-center  pb-2"
                    style="font-weight: bold;border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                    <div>
                        <label class="form-label">
                        <span>{{ i18n.global.locale == 'en' ? item.name_en : item.name }}</span>
                    </label>
                    </div>
                </div>
                <!-- 字段部分 -->
                <div class="row  d-flex justify-content-start mt-2">
                    <textarea v-model="item.value" @change="changeName" class="form-control"  id="exampleFormControlTextarea5" rows="3"></textarea>
                </div>
            </div>
        </b-card>
    </template>
</template>
<style></style>